export default __webpack_public_path__ + "media/images/features/local_delivery/ogp-f736d48fb6caa91ce81c19e65fe6a971.jpg";